import { apiClient } from './client';

// ---------- API keys ----------
export interface ApiKey {
  id: string;
  name: string;
  prefix: string;
  scopes: string[];
  lastUsedAt: string | null;
  revokedAt: string | null;
  createdAt: string;
}

export interface CreatedApiKey {
  id: string;
  key: string; // se muestra UNA sola vez
  prefix: string;
  scopes: string[];
}

export const API_SCOPES = [
  'sessions:write',
  'conversations:read',
  'messages:read',
  'messages:write',
  'payments:read',
] as const;

export const apiKeysApi = {
  list: async (): Promise<ApiKey[]> => {
    const { data } = await apiClient.get('/admin/api-keys');
    return data as ApiKey[];
  },
  create: async (body: { name: string; scopes: string[] }): Promise<CreatedApiKey> => {
    const { data } = await apiClient.post('/admin/api-keys', body);
    return data as CreatedApiKey;
  },
  revoke: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/api-keys/${id}`);
  },
};

// ---------- Webhooks ----------
export interface WebhookEndpoint {
  id: string;
  url: string;
  events: string[];
  isActive: boolean;
  secretPreview: string;
  createdAt: string;
}

export interface CreatedWebhook {
  id: string;
  url: string;
  events: string[];
  secret: string; // se muestra UNA sola vez
}

export const WEBHOOK_EVENTS = [
  'message.created',
  'payment.created',
  'payment.approved',
  'payment.rejected',
  'withdraw.requested',
  'withdraw.paid',
  'withdraw.rejected',
] as const;

export const webhooksApi = {
  list: async (): Promise<WebhookEndpoint[]> => {
    const { data } = await apiClient.get('/admin/webhooks');
    return data as WebhookEndpoint[];
  },
  create: async (body: { url: string; events: string[] }): Promise<CreatedWebhook> => {
    const { data } = await apiClient.post('/admin/webhooks', body);
    return data as CreatedWebhook;
  },
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/webhooks/${id}`);
  },
  test: async (id: string): Promise<void> => {
    await apiClient.post(`/admin/webhooks/${id}/test`, {});
  },
};
